import { Button, Divider, Flex, Text, Title } from '@tremor/react'
import { useEffect, useState } from 'react'

interface IContactUs {
    show: boolean
    onClose: () => void
}

export default function ContactUs({ show, onClose }: IContactUs) {
    const [isVisible, setIsVisible] = useState(show)

    useEffect(() => {
        if (show) {
            setIsVisible(true)
            return () => 0
        }
        const timeout = setTimeout(() => setIsVisible(false), 150)
        return () => clearTimeout(timeout)
    }, [show])

    return (
        <Flex
            flexDirection="col"
            justifyContent="center"
            alignItems="center"
            className={`fixed top-0 left-0 w-screen h-screen bg-gray-900/50 z-50 transition-opacity duration-75 ease-linear ${
                show ? 'opacity-100 visible' : 'opacity-0'
            } ${isVisible ? 'visible' : 'invisible'}`}
            onClick={onClose}
        >
            <Flex
                flexDirection="row"
                alignItems="start"
                justifyContent="start"
                className="w-fit h-fit bg-white rounded-md border-l border-gray-300"
                onClick={(e) => {
                    e.stopPropagation()
                }}
            >
                <Flex
                    flexDirection="col"
                    justifyContent="start"
                    alignItems="center"
                    className="p-4"
                >
                    <Title className="p-4 text-4xl text-teal-700">
                        Contact US
                    </Title>
                    <Text className="!text-xl text-black text-center mb-8">
                        Please contact us so that we can provide you with a paid
                        tier service.
                    </Text>
                    <Text className="!text-lg text-teal-800">
                        308 View Tower, Mouj St, Muscat, Oman
                    </Text>
                    <Text className="!text-lg text-gray-700">
                        Phone:{' '}
                        <span className="text-teal-800">+968 7755 8520</span>
                    </Text>
                    <Text className="!text-lg text-gray-700">
                        Email:{' '}
                        <span className="text-teal-800">
                            sales@watadtech.om
                        </span>
                    </Text>
                    <Flex
                        flexDirection="row"
                        justifyContent="between"
                        alignItems="start"
                        className="px-8 w-fit space-x-10 py-6"
                    >
                        <Button
                            variant="secondary"
                            color="gray"
                            onClick={onClose}
                        >
                            Close
                        </Button>
                    </Flex>
                </Flex>
            </Flex>
        </Flex>
    )
}
